module.exports = __webpack_public_path__ + "img/na.74257fb2.svg";